(function () {
  var KEY = 'valor_cart_countdown_end';
  var SECONDS = 600;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick(el) {
    if (!el) return;
    var end = parseInt(sessionStorage.getItem(KEY), 10);
    if (!end || end < Date.now()) {
      end = Date.now() + SECONDS * 1000;
      sessionStorage.setItem(KEY, String(end));
    }
    var left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    var m = Math.floor(left / 60);
    var s = left % 60;
    el.textContent =
      pad(m) + ':' + pad(s) + ' until your order expires';
    if (left <= 0) {
      el.textContent = 'Complete checkout to secure your order';
      return;
    }
    setTimeout(function () { tick(el); }, 1000);
  }

  function fixHomeHeroLinks() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    var links = {
      'Shop all': '/collections/summer-steals',
      'Shop Now': '/collections/men',
      'SHOP NEW ARRIVALS': '/collections/all'
    };
    document.querySelectorAll('.hero__link a.btn, .hero__link a.btn--inverse').forEach(function (anchor) {
      var label = (anchor.textContent || '').trim();
      var href = anchor.getAttribute('href');
      if ((!href || href === '#') && links[label]) {
        anchor.setAttribute('href', links[label]);
      }
    });
  }

  function init() {
    fixHomeHeroLinks();
    document.querySelectorAll('[data-valor-countdown]').forEach(tick);

    var msgs = [
      'Free UK delivery',
      'Tracked shipping on all orders',
      'Up to 50% off while stock lasts'
    ];
    var idx = 0;
    document.querySelectorAll('[data-valor-announcement-text]').forEach(function (el) {
      setInterval(function () {
        el.style.opacity = '0';
        setTimeout(function () {
          idx = (idx + 1) % msgs.length;
          el.textContent = msgs[idx];
          el.style.opacity = '1';
        }, 350);
      }, 5000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
